<template>
  <div class="">
    <div class="flexbox user_box" :style="`bottom:${heigth}rem`">
      <div class="user_icon"><img :src="appUser.avtarUrl" alt="" /></div>
      <div class="user_info">
        <div>
          {{ appUser.nickName }}
          <span>({{ appUser.mobileNumber | phoneFilter }})</span>
        </div>
        <div class="userid">友邻少年ID:{{ appUser.userId }}</div>
      </div>
      <div class="flexbox change" v-if="!appUser.isWeixin" @click="changeUser">
        切换账号
        <img src="../../../../images/payment/qiehuan.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { appUser, storage } from '@/utils'
import { toLoginView } from '@/utils/init/env-init'
export default {
  props: {
    heigth: {
      type: Number,
      default: 1.25
    }
  },
  data() {
    return {
      appUser
    }
  },
  filters: {
    phoneFilter(str) {
      var reg = /^(\d{3})\d{4}(\d{4})$/
      return str.replace(reg, '$1****$2')
    }
  },
  created() {},
  methods: {
    changeUser() {
      Dialog.confirm({
        message: '确认要退出登录,并切换其他账号吗?',
        confirmButtonColor: '#00B25A'
      })
        .then(() => {
          // on confirm
          storage.AppUserKeySwitch().setItem({ switchPhone: true })
          toLoginView({ type: 'button', action: 'changeUser' })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang="less" scoped>
.user_box {
  position: fixed;
  width: 100%;
  left: 0;
  z-index: 10;
  padding: 0.24rem 0.48rem;
  justify-content: space-between;
  background-color: #fff;
  border-top: 1px solid #f7f9fb;
  border-radius: 0.28rem 0.28rem 0rem 0rem;
  box-shadow: 0rem 0rem 0rem 0rem rgba(0, 0, 0, 0.15);
  .user_icon {
    img {
      display: block;
      width: 0.92rem;
      border-radius: 50%;
      margin-right: 0.16rem;
    }
  }
  .user_info {
    flex: auto;
    font-size: 0.28rem;
    .userid {
      color: #999;
      font-size: 0.24rem;
      margin-top: 0.15rem;
    }
  }
  .change {
    font-size: 0.24rem;
    color: #838383;
    img {
      display: block;
      width: 0.24rem;
      height: 0.24rem;
      margin-left: 10px;
    }
  }
}
</style>
